import React, {
  useContext,
  useState,
  useEffect,
  useRef,
  lazy,
  Suspense,
} from "react";
import { ReactComponent as PhoneIcon } from "../../assets/icons/phone.svg";
import ButtonForm from "../../components/ButtonForm";
import Header from "../../components/Header";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { marcacionPortEnviarCodigo } from "../../utils/analytics";
import { Context } from "../../context/Context";
import {
  getJsonOffersPorta,
  servicePost,
  servicePostSession,
} from "../../services/serviceAPI";
import InputNumberForm from "../../components/InputNumberForm";
import {
  PurchaseDetail,
  SwipeableEdgeDrawer,
} from "../../components/PurchaseDetail";
import ModalErrorNIP from "../../components/Modal/ModalErrorNIP";
import { createStep } from "../../utils/utils";
import { v4 as uuidv4 } from "uuid";
const Footer = lazy(() => import("../../components/Footer"));
const Loading = lazy(() => import("../../components/Loading"));
const ModalVerification = lazy(() =>
  import("../../components/Modal/ModalVerification")
);
const ModalError = lazy(() =>
  import("../../components/Modal/ModalError")
);
const ModalOrden = lazy(() =>
  import("../../components/Modal/ModalOrder")
);
const ModalInicioPorta = lazy(() =>
  import("../../components/Modal/ModalInicioPorta")
);

const stepsPorta = [
  createStep("1", "Verificación", "active"),
  createStep("2", "Tus datos"),
  createStep("3", "Recibe tu SIM", "", false),
];

const stepsVerificationPorta = [
  createStep("1", "Verificación", "complete", true, true),
  createStep("2", "Tus datos", "active", true, true),
  createStep("3", "Recibe tu SIM", "", false),
];

const Datos = () => {
  const locationState = useLocation().state;
  const [searchParams, setSearchParams] = useSearchParams();
  const idOffer = searchParams.get("offeringId");
  const phoneNumberUrl = searchParams.get("numeroReferido");
  const [openModalVerification, setOpenModalVerification] = useState(false);
  const navigate = useNavigate();
  const [isEmptyPhoneNumber, setIsEmptyPhoneNumber] = useState(false);
  const [errorPhoneNumber, setErrorPhoneNumber] = useState(false);
  const [errorPhoneNumberValue, setErrorPhoneNumberValue] = useState(false);
  const [loading, setLoading] = useState(false);
  const [msgLoading, setMsgLoading] = useState(null);
  const [showErrorForm, setShowErrorForm] = useState(false);
  const [modalInicioPorta, setModalInicioPorta] = useState(true);
  const [procesoPorta, setProcesoPorta] = useState(false);
  const [itemLock, setItemLock] = useState({});
  const [mnpNip, setMnpNip] = useState("");
  const [openModalError, setOpenModalError] = useState(false);
  const [openModalOrden, setOpenModalOrden] = useState(false);
  const [orden, setOrden] = useState(null);
  const [errItemLock, setErrItemLock] = useState(false);
  const [showItemLock, setShowItemLock] = useState(false);
  const [showError, setShowError] = useState(false);
  const [openModalErrorNIP, setOpenModalErrorNIP] = useState(false);
  const [errorMsg, setErrorMsg] = useState(
    "¡Ups! Ocurrió un error inesperado, por favor vuelve a intentar"
  );
  const [errorMsgHidden, setErrorMsgHidden] = useState();
  const initialTime = 300;
  const [timeLeftCountdown, setTimeLeftCountdown] = useState(initialTime);
  const [paused, setPaused] = useState(true);
  const refPhoneNumber = useRef(null);
  const {
    dataPage,
    setDataPage,
    setOferta,
    oferta,
    errorMsgContext,
    setErrorMsgContext,
    showTelnum,
    setShowTelnum,
    phoneNumber,
    setPhoneNumber,
    setOfferDataDetail,
    currentOperator,
    setCurrentOperator,
    setNumberType,
    sessionID,
    setSessionID,
    setOffer,
    setSessionNip
  } = useContext(Context);

  function handleOpenModalVerification() {
    setLoading(true);
    setPaused(false);
    const requestMnpNIP = Promise.resolve(
      servicePostSession(phoneNumber, sessionID, "portabilidad/requestMnpNIP")
    );
    requestMnpNIP
      .then((response) => {
        if (response?.data?.returnCode === "60107463097") {
          setOpenModalErrorNIP(true);
          setLoading(false);
          return;
        }
        setTimeLeftCountdown(initialTime);
        setOpenModalVerification(true);
        setMnpNip(response);
        setLoading(false);
      })
      .catch((error) => {
        setOpenModalError(true);
        setErrorMsg(error.resMsg);
        setLoading(false);
      });
  };

  const handleCloseModalVerification = () => setOpenModalVerification(false);

  //Use Effect Inicial
  useEffect(() => {
    let isMounted = true;
    if (phoneNumberUrl) {
      setPhoneNumber(phoneNumberUrl);
      setNumberType("mnp");
      executeServicesNumber(phoneNumberUrl);
    }
    const fetchData1 = async () => {
      try {
        const requests = [servicePost(idOffer, "transversaloffer/offerDetail")];
        setSessionID(uuidv4());
        const [offerDetailResponse] = await Promise.all(requests);

        if (!isMounted) return;

        if (offerDetailResponse.data.code !== "200") {
          setOpenModalError(true);
          setErrorMsgHidden(
            `offerDetail - ${offerDetailResponse.data.code} - ${offerDetailResponse.data.type}`
          );
        }
        setOfferDataDetail(offerDetailResponse);
        const offer = {
          offerId: offerDetailResponse.data.serviceResponse[0].offeringId,
          offerName: offerDetailResponse.data.serviceResponse[0].offeringName,
          offerPrice: offerDetailResponse.data.serviceResponse[1].unitPrice,
        };
        setOffer(offer);
        getOffers();
      } catch (error) {
        setOpenModalError(true);
        setErrorMsgHidden(error.message);
      }
    };

    const fetchAllData = async () => {
      try {
        await Promise.all([fetchData1()]);
      } catch (error) {
        console.error("Error al ejecutar las solicitudes en paralelo:", error);
      }
    };
    if (isMounted) {
      fetchAllData();
    }
    return () => {
      isMounted = false;
    };
  }, []);

  //UseEffect phoneNumber
  useEffect(() => {
    getOffers();
    setPaused(true);
    setTimeLeftCountdown(initialTime);

    if (phoneNumber.length !== 10 || oferta.lineaNueva !== "N") {
      setCurrentOperator({
        operatorCode: "",
        operatorName: "",
      });
      if (showError) {
        return;
      }
    } else {
      setLoading(true);
      setNumberType("mnp");
      executeServicesNumber(phoneNumber);
    }
  }, [phoneNumber]);

  async function getOffers() {
    try {
      const ofertas = await getJsonOffersPorta();
      setOferta(ofertas[idOffer]);
    } catch (error) {
      setOpenModalError(true);
    }
  }

  const validatePhoneNumber = (event, set) => {
    const regex = /^[0-9\b ]+$/;
    if (event.target.value === "" || regex.test(event.target.value)) {
      const phoneClean = event.target.value.split(" ").join("");
      set(phoneClean);
    }
  };

  const onCloseModalError = () => {
    if (showError) {
      window.location.reload();
      return;
    }
    setOpenModalError(false);
    setErrorMsgContext(null);
  };

  const onCloseModalPorta = () => {
    setModalInicioPorta(false);
  };

  const onCloseModalOrden = () => {
    setOpenModalOrden(false);
    setErrorMsgContext(null);
  };

  function validateFields() {
    return (
      phoneNumber &&
      phoneNumber !== "" &&
      phoneNumber.length === 10 &&
      !errorPhoneNumber
    );
  };

  const validatePhoneNumberValue = (event) => {
    if (event.target.value.length < 12) {
      setErrorPhoneNumberValue(true);
    } else {
      setErrorPhoneNumberValue(false);
    }
  };

  const handleMoveError = (inputRef) => {
    inputRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  useEffect(() => {
    if (errItemLock && showError) {
      setLoading(false);
      setOpenModalError(true);
    }
  }, [errItemLock, showError]);

  function handleClickNextStep() {
    if (!phoneNumber || phoneNumber === "") {
      setIsEmptyPhoneNumber(true);
      handleMoveError(refPhoneNumber);
    }
    if (validateFields()) {
      marcacionPortEnviarCodigo({
        phoneNumber: phoneNumber,
        plan: `${oferta.tituloOferta}-${oferta.vigencia}`,
        valor: oferta.total.replace(/\./g, ""),
      });
      setLoading(true);
      setMsgLoading("Por favor espera unos segundos");
      if (locationState?.intentoNuevo) {
        navigate("/datos?" + searchParams.toString());
        return;
      }
      handleOpenModalVerification();
    } else {
      setShowErrorForm(true);
    }
  };

  useEffect(() => {
    if (Object.entries(itemLock).length > 0 && showItemLock) {
      handleClickNextStep();
    }
  }, [itemLock, showItemLock, handleClickNextStep]);

  useEffect(() => {
    const timerId = setInterval(() => {
      if (!paused) {
        setTimeLeftCountdown((timeLeftCountdown) => timeLeftCountdown - 1);
      }
    }, 1000);

    return () => clearInterval(timerId);
  }, [paused]);

  const executeServicesNumber = (phoneNumber) => {
    Promise.all([
      servicePostSession(phoneNumber, sessionID, "portabilidad/queryOrder"),
      servicePostSession(phoneNumber, sessionID, "portabilidad/resolveCurrentOperator"),
    ])
      .then(([queryOrderResponse, telNumResponse]) => {
        // Process the queryOrderService response
        if (
          queryOrderResponse.data === "No hay ordenes pendientes" ||
          queryOrderResponse.data === "La orden no existe."
        ) {
          setLoading(false);
        } else if (
          queryOrderResponse.data ===
          "Se presentó un fallo durante la operación"
        ) {
          setLoading(false);
          setOpenModalError(true);
          setPhoneNumber("");
        } else {
          setLoading(false);
          setOrden(queryOrderResponse.data);
          setOpenModalOrden(true);
        }
        const { donorOperatorName, donorOperatorCode } =
          telNumResponse.data.resolveCurrentOperatorResponse
            .operatorResponseRCOItem.portabilityItem.rspBodyRCOAuxItem;
        if (donorOperatorCode === "00004") {
          setShowTelnum(false);
          setErrorPhoneNumber(true);
        } else {
          setShowTelnum(true);
          setCurrentOperator({
            operatorCode: donorOperatorCode,
            operatorName: donorOperatorName,
          });
          setErrorPhoneNumber(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        setShowTelnum(false);
        setOpenModalError(true);
        setErrorMsg("El número ingresado no es válido. Por favor, verifica y vuelve a intentarlo.")
        setErrorMsgHidden(`Error - ${error.message}`);
      });
  };

  return (
    <div className="flex flex-col justify-between h-screen sm:h-screen bg-[#f5f5f5] font-telefonica">
      <div>
        <Header
          steps={openModalVerification ? stepsVerificationPorta : stepsPorta}
        />
      </div>
      <div className="bg-[#f5f5f5] flex-auto flex sm:flex-row flex-col px-5 py-5 space-x-0 sm:space-x-8 space-y-4 sm:space-y-0 w-full justify-center">
        <div className="flex flex-col text-left justify-center sm:justify-start sm:w-[728px] w-full py-2 sm:py-16">
          <h2 className="text-[18px] sm:text-[32px] leading-10 text-titleTelefonica font-telefonicaBold">
            Pásate con tu número a Movistar
          </h2>
          <h4 className="text-sm sm:text-lg mt-1 mb-6 text-subtitleTelefonica">
            Queremos verificar que la línea te pertenece, te enviaremos un SMS{" "}
            <br className="hidden sm:flex" />
            con un código de verificación
          </h4>
          <div className="flex flex-col space-y-4 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-4 gap-2">
            <div>
              <InputNumberForm
                inputRef={refPhoneNumber}
                name="phoneNumber"
                type="phoneNumber"
                mask={[
                  /3/,
                  /\d/,
                  /\d/,
                  " ",
                  /\d/,
                  /\d/,
                  /\d/,
                  " ",
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                ]}
                isNumber={true}
                handleChange={(event) => {
                  validatePhoneNumber(event, setPhoneNumber);
                  validatePhoneNumberValue(event);
                  setIsEmptyPhoneNumber(false);
                }}
                error={isEmptyPhoneNumber || errorPhoneNumber}
                value={phoneNumber}
                helperText={
                  isEmptyPhoneNumber
                    ? "Este campo es obligatorio"
                    : "Línea inválida"
                }
                icon={<PhoneIcon />}
                label="Línea que cambias a Movistar"
              />
              {errorPhoneNumberValue ? (
                <div style={{ textAlign: "left" }}>
                  <span className="text-[#d32f2f] ml-4 font-telefonica text-xs">
                    El número debe ser de 10 digitos
                  </span>
                </div>
              ) : (
                <></>
              )}
            </div>
            <div className="w-full col-start-1 col-span-2 sm:col-start-2 sm:col-span-1 sm:justify-end">
              <ButtonForm
                fullWidth={true}
                onClick={handleClickNextStep}
                disabled={phoneNumber.length !== 10 || currentOperator.operatorCode === ""}
                title="Enviar código de verificación"
              />
              {showErrorForm && !validateFields() ? (
                <div className="text-errorTelefonica text-sm font-telefonica text-center">
                  Verifica los datos ingresados
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
        <PurchaseDetail
          tituloOferta={oferta.tituloOferta}
          vigencia={oferta.vigencia}
          datos={oferta.datos}
          freefire={oferta.freefire}
          youtube={oferta.youtube}
          perplexity={oferta.perplexity}
          internacional={oferta.internacional}
          bonoBienvenida={oferta.bonoBienvenida}
          appsIncluidas={oferta.appsIncluidas}
          simCard={oferta.simCard}
          envio={oferta.envio}
          antes={oferta.antes}
          ahora={oferta.ahora}
          total={oferta.total}
          showTelnum={showTelnum}
          telNum={phoneNumber}
          className="hidden sm:inline"
        />
        <SwipeableEdgeDrawer
          tituloOferta={oferta.tituloOferta}
          vigencia={oferta.vigencia}
          datos={oferta.datos}
          freefire={oferta.freefire}
          youtube={oferta.youtube}
          internacional={oferta.internacional}
          bonoBienvenida={oferta.bonoBienvenida}
          appsIncluidas={oferta.appsIncluidas}
          simCard={oferta.simCard}
          envio={oferta.envio}
          perplexity={oferta.perplexity}
          antes={oferta.antes}
          telNum={phoneNumber}
          ahora={oferta.ahora}
          total={oferta.total}
          showTelnum={showTelnum}
        />
      </div>
      <Suspense fallback={<></>}>
        <Footer />
      </Suspense>
      <Suspense fallback={<></>}>
        {openModalVerification && (
          <ModalVerification
            dataPage={dataPage}
            setDataPage={setDataPage}
            handleClose={handleCloseModalVerification}
            open={openModalVerification}
            setOpenModalVerification={setOpenModalVerification}
            phoneNumber={phoneNumber}
            setMnpNip={setMnpNip}
            setSessionNip={setSessionNip}
            setOpenModalError={setOpenModalError}
            setErrorMsg={setErrorMsg}
            setLoading={setLoading}
            oferta={oferta}
            timeLeftCountdown={timeLeftCountdown}
            setPaused={setPaused}
            paused={paused}
            setTimeLeftCountdown={setTimeLeftCountdown}
          />
        )}
      </Suspense>
      <Suspense fallback={<></>}>
        <ModalError
          open={openModalError || errorMsgContext}
          handleClose={onCloseModalError}
          msg={errorMsg || errorMsgContext}
          msgHidden={errorMsgHidden}
        />
      </Suspense>
      <Suspense fallback={<></>}>
        {openModalErrorNIP && (
          <ModalErrorNIP
            open={openModalErrorNIP}
            handleClose={() => setOpenModalErrorNIP(false)}
            handleOpenNIP={() => setOpenModalVerification(true)}
            handleServiceNIP={() => handleOpenModalVerification()}
            timeLeftCountdown={timeLeftCountdown}
            setPaused={setPaused}
            paused={paused}
            setTimeLeftCountdown={setTimeLeftCountdown}
          />
        )}
      </Suspense>
      <Suspense fallback={<></>}>
        <ModalOrden
          open={openModalOrden}
          handleClose={onCloseModalOrden}
          setLoading={setLoading}
          phoneNumber={phoneNumber}
          orden={orden}
          setOpenModalError={setOpenModalError}
          setErrorMsgHidden={setErrorMsgHidden}
        />
      </Suspense>
      <Suspense fallback={<></>}>
        <ModalInicioPorta
          open={modalInicioPorta}
          handleClose={onCloseModalPorta}
          actionAceptar={setProcesoPorta}
        />
      </Suspense>
      <Suspense fallback={<></>}>
        <Loading show={loading} msg={msgLoading} />
      </Suspense>
    </div>
  );
};

export default Datos;